const getPricingContextVatInclusivity = () => {
  const doc = getDocument();
  try {
    return doc?.pcxtV3?.isVatInclusive() ?? "";
  } catch {
    return "";
  }
};

const getPricingContext = () => {
  const doc = getDocument();
  try {
    return doc?.pcxtV3?.getEncodedContextString() ?? "";
  } catch {
    return "";
  }
};

const isPricingContextInitialized = (developmentMode?: boolean): boolean => {
  const doc = getDocument();
  return developmentMode ? true : doc?.pcxtV3?.isInitialized() ?? false;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getDocument = (): any => {
  return typeof document !== "undefined" ? document : undefined;
};

export { getPricingContext, getPricingContextVatInclusivity, isPricingContextInitialized };
